// @flow

import * as Immutable                              from 'immutable';
import { handleActions }                           from 'redux-actions';
import { combineReducers }                         from 'redux-immutable';
import clearCookieNotAllowedModal                  from '../actions/cookieSettings/clearCookieNotAllowedModal';
import type { DisplayCookieNotAllowedModalAction } from '../actions/cookieSettings/displayCookieNotAllowedModal';
import displayCookieNotAllowedModal                from '../actions/cookieSettings/displayCookieNotAllowedModal';
import type {
  CookieTypeSetting,
  UpdateCookieSettingsAction,
}                                                  from '../actions/cookieSettings/updateUserCookieSettings';
import updateUserCookieSettings                    from '../actions/cookieSettings/updateUserCookieSettings';
import type { CookieType }                         from '../config/cookiesConfig';


// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

type CookieSettingsState = Immutable.Map<CookieType, CookieTypeSetting>;

type CookieBlockedComponentState = Immutable.Map<'displayForCookieType', *>;

type CookieComponentsState = Immutable.Map<CookieComponentType, *>;


// -----------------------------------------------------------------------------------------------------------------
// Reducers
// -----------------------------------------------------------------------------------------------------------------


// userSettings
// ------------
const userSettings = handleActions(
  {
    [String(updateUserCookieSettings)](state: CookieSettingsState, action: UpdateCookieSettingsAction) {
      const {payload: {cookieSettings}} = action;

      // $FlowFixMe
      const cookieSettingsMap: Immutable.Map<CookieType, CookieTypeSetting> = Immutable.fromJS(cookieSettings);

      if (!cookieSettingsMap instanceof Immutable.Map) {
        throw new Error('cookieSettings should be an object');
      }

      const updatedState = cookieSettingsMap.reduce(
        (updatedState, cookieTypeSetting, cookieType) => {
          const cookieTypeSettingMap = Immutable.Map(cookieTypeSetting);

          return Immutable.is(state.get(cookieType), cookieTypeSettingMap)
            ? updatedState
            : updatedState.set(cookieType, cookieTypeSettingMap)
        },
        state,
      );

      if (Immutable.is(updatedState, state)) {
        return state;
      }

      return updatedState;
    },
  },
  Immutable.Map(),
);


// components
// ----------

// cookieBlockedModal

const cookieBlockedModal = handleActions(
  {
    [String(displayCookieNotAllowedModal)](state: CookieBlockedComponentState,
                                           action: DisplayCookieNotAllowedModalAction) {
      return state.set('displayForCookieType', Immutable.List(action.payload.cookieTypes));
    },
    [String(clearCookieNotAllowedModal)](state: CookieBlockedComponentState) {
      return state.set('displayForCookieType', Immutable.List());
    },
  },
  Immutable.Map({displayForCookieType: Immutable.List()}),
);

const components = combineReducers({cookieBlockedModal});


export default combineReducers({userSettings, components});



// WEBPACK FOOTER //
// ./src/reducers/cookieSettings.js